var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("pa-skeleton-loader" + (_vm.shimmer ? ' shimmer' : '')),style:(_vm.styleObject),attrs:{"role":"alert","aria-busy":true,"aria-live":"polite"}})}
var staticRenderFns = []

export { render, staticRenderFns }